// import React, { useEffect, useState, useMemo, useRef } from "react";

// import { fetchStockData } from "./services";

// import formatStockData from "./utils";

// import ReactApexChart from "react-apexcharts";

// import { Bars } from "react-loader-spinner";

// import { BsArrowLeft } from "react-icons/bs";

// import loader_video from "../assets/loaderaltra.gif";

// import axios from "axios";

// import { IoArrowBack } from "react-icons/io5";

// import moment from "moment";

// import { useNavigate } from "react-router-dom";

// import { Space } from "antd";

// import { DownOutlined } from "@ant-design/icons";

// import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

// import { LineWave } from "react-loader-spinner";



// // <---this is the file of generate graphs OF eventhistory PAGE----> URL : graphdata ------->

// const CandleUser = () => {

//   const navigate = useNavigate();

//   const [stockData, setStockData] = useState([]);

//   const [countryname, setcountryname] = useState("");

//   const [eventname, seteventname] = useState("");

//   const [loading, setLoading] = useState(true);

//   const [loading1, setLoading1] = useState(true);

//   const chartRefs = useRef([]);

//   const [noDataAvailable, setNoDataAvailable] = useState(false);

//   const [fullScreenIndex, setFullScreenIndex] = useState(null);

//   //  const [selectedModel, setSelectedModel] = useState("GBP/USD");

//   const [selectedModel, setSelectedModel] = useState("");

//   const [selectedhour, setSelectedhour] = useState("30min");



//   const [extractedDateandTime, setExtractedDateandTime] = useState([]);

//   const [directions, setDirections] = useState([]);

//   const findHighLow = (dataArray) => {

//     let highestHigh = -Infinity;

//     let lowestLow = Infinity;



//     dataArray.forEach((item) => {

//       if (

//         item &&

//         typeof item.High === "number" &&

//         typeof item.Low === "number"

//       ) {

//         highestHigh = Math.max(highestHigh, item.High);

//         lowestLow = Math.min(lowestLow, item.Low);

//       }

//     });



//     return { highestHigh, lowestLow };

//   };



//    const seriesData = useMemo(() => {

//      // Step 1: Group raw data by model and date

//      const rawGroups = stockData.flatMap((item) => {

//        const dateGroups = {};



//        // Group data points by date for this item

//        item.data.forEach((point) => {

//          const date = point.date; // e.g., "28.08.2025"

//          if (!dateGroups[date]) {

//            dateGroups[date] = [];

//          }

//          dateGroups[date].push(point);

//        });



//        // Create a group for each date with flattened data points

//        // CRITICAL FIX: Iterate over the sorted keys of dateGroups to ensure consistent order

//        const sortedDateKeys = Object.keys(dateGroups).sort((a, b) =>

//          moment(a, "DD.MM.YYYY").diff(moment(b, "DD.MM.YYYY"))

//        );

//        return sortedDateKeys.map((date) => {

//          const flattenedData = dateGroups[date]

//            .sort((a, b) =>

//              moment(a.time, "HH:mm:ss").diff(moment(b.time, "HH:mm:ss"))

//            ) // Sort data points by time within the date

//            .map((point) => ({

//              x: point.time.slice(0, 5), // e.g., "23:45"

//              y: [

//                parseFloat(point.Open),

//                parseFloat(point.High),

//                parseFloat(point.Low),

//                parseFloat(point.Close),

//              ],

//            }));

//          return {

//            model: item.model,

//            date, // Keep the original date e.g., "28.08.2025"

//            data: flattenedData, // Renamed 'flattenedData' to 'data' to match your original structure

//          };

//        });

//      });



//      // Step 2: Group the raw groups by model

//      const groupsByModel = rawGroups.reduce((acc, group) => {

//        if (!acc[group.model]) {

//          acc[group.model] = [];

//        }

//        acc[group.model].push(group);

//        return acc;

//      }, {});



//      // Step 3: Sort groups by date in descending order (most recent first)

//      const sortedGroupsByModel = {};

//      Object.keys(groupsByModel).forEach((model) => {

//        sortedGroupsByModel[model] = groupsByModel[model].sort((a, b) =>

//          moment(b.date, "DD.MM.YYYY").diff(moment(a.date, "DD.MM.YYYY"))

//        );

//      });



//      // Step 4: Flatten the groups across models

//      const finalGroups = Object.values(sortedGroupsByModel).flat();

//      console.log("Final seriesData:", finalGroups); // Add this log to verify

//      return finalGroups;

//    }, [stockData]);



//   // useEffect(() => {

//   //   if (seriesData.length > 0) {

//   //     setSelectedModel(seriesData[0].model);

//   //   }

//   // }, [seriesData]);

//   //   useEffect(() => {

//   //   if (seriesData.length > 0) {

//   //     setSelectedModel(seriesData[0].model);

//   //   }

//   // }, [seriesData]);



//   useEffect(() => {

//     if (

//       seriesData.length > 0 &&

//       (!selectedModel || !seriesData.some((s) => s.model === selectedModel))

//     ) {

//       setSelectedModel(seriesData[0].model);

//     }

//   }, [seriesData, selectedModel]);



//   const filteredSeriesData = seriesData.filter(

//     (series) => series.model === selectedModel

//   );

//   // console.log("filteredSeriesData" , filteredSeriesData)



//   const handleGraphClick = (index) => {

//     setFullScreenIndex(index); // Set the clicked graph to full screen

//   };



//   const handleCloseFullScreen = () => {

//     setFullScreenIndex(null); // Reset to hide full-screen

//   };



//   const [EventData, SetEventData] = useState([]);

//   const final_Movement = async () => {

//     try {

//       setLoading1(true);

//       const urlParams = new URLSearchParams(window.location.search);

//       const eventName = decodeURIComponent(urlParams.get("eventName"));

//       const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));



//       // console.log("selectedhour" , selectedhour)

//       const response = await axios.post(`${process.env.REACT_APP_URL}/graph`, {

//         eventName,

//         eventcountry,

//         selectedhour,

//       });

//       const data = response.data.finalData;

//       const getExtractedTime = response.data.extractedDatesAndTimes;

//       // console.log("getExtractedTime" , getExtractedTime)



//       setExtractedDateandTime(getExtractedTime);



//       setStockData(data);

//       seteventname(eventName);

//       setcountryname(eventcountry);



//       // console.log("response.data.findevent" , response.data.findevent)

//       SetEventData(response.data.findevent);

//       console.log("EventData kush", response.data.findevent);

//       setLoading1(false);

//       setLoading(false);

//     } catch (error) {

//       console.error("Error fetching data:", error);

//       console.log("error", error);

//     }

//   };



//   const findColorForFinalMovement = () => {

//     return EventData.map((item) => {

//       let color, sign;



//       if (

//         item.estimate === null ||

//         item.estimate === "" ||

//         item.actual - item.estimate === 0

//       ) {

//         if (item.actual - item.previous > 0) {

//           color = "bg-[#78e9a036]"; // Green

//           sign = "Positive";

//         } else if (item.actual - item.previous === 0) {

//           color = "bg-[#ffeb552b]"; // Yellow

//           sign = "Flat";

//         } else {

//           color = "bg-[#ff8e8e52]"; // Red

//           sign = "Negative";

//         }

//       } else {

//         if (item.actual - item.estimate > 0) {

//           color = "bg-[#78e9a036]"; // Green

//           sign = "Positive";

//         } else if (item.actual - item.estimate === 0) {

//           color = "bg-[#ffeb552b]"; // Yellow

//           sign = "Flat";

//         } else {

//           color = "bg-[#ff8e8e52]"; // Red

//           sign = "Negative";

//         }

//       }



//       // console.log("color" , color , sign)

//       return { color, sign };

//     });

//   };



//   const getNewsDirectionFromFinalMovement = (dataArray) => {

//     return dataArray.map((item) => {

//       const finalMovementNum = Number(item.finalMovement);

//       let color, sign;



//       if (finalMovementNum > 0) {

//         color = "bg-[#78e9a036]"; // Green

//         sign = "Positive";

//       } else if (finalMovementNum === 0) {

//         color = "bg-[#ffeb552b]"; // Yellow

//         sign = "Flat";

//       } else {

//         color = "bg-[#ff8e8e52]"; // Red

//         sign = "Negative";

//       }



//       return { color, sign };

//     });

//   };



//   const fetchDatacolor = async () => {

//     try {

//       const urlParams = new URLSearchParams(window.location.search);

//       const eventId = decodeURIComponent(urlParams.get("eventId"));

//       console.log("eventId", eventId);

//       // alert(eventId);

//       const response = await fetch(

//         `${process.env.REACT_APP_URL}/user/geteventtable/${eventId}?eventRange=6&eventType=1min`

//       );

//       if (!response.ok) {

//         throw new Error(`HTTP error! status: ${response.status}`);

//       }

//       const json = await response.json();

//       const volatilityOutput = json.volatilityEvent?.data?.output || [];

//       const calculatedDirections =

//         getNewsDirectionFromFinalMovement(volatilityOutput);

//       console.log("calculatedDirections kk", calculatedDirections);

//       setDirections(calculatedDirections);

//     } catch (e) {

//       console.log(e.message);

//     } finally {

//       // setLoading(false);

//     }

//   };

//   const colorData = findColorForFinalMovement();



//   useEffect(() => {

//     final_Movement();

//     findColorForFinalMovement();

//     fetchDatacolor();

//   }, [selectedhour]);

//   let chartOptions = [];



//   filteredSeriesData.map((currentItem, index) => {

//     const firstCandle = currentItem.data[0]?.x; // First candle x-axis value

//     const lastCandle = currentItem.data[currentItem.data.length - 1]?.x; // Last candle x-axis value

//     // console.log("firstCandle" , firstCandle , lastCandle)

//     // console.log("colorData[index]?.sign" , colorData[index]?.sign)

//     const xAnnotations = extractedDateandTime

//       .filter(({ date, time }) => {

//         const formattedDate = date.split(".").reverse().join("."); // Convert to YYYY.MM.DD

//         const extractedTime = time.slice(0, 5); // Extract "HH:mm" from "HH:mm:ss"

//         const currentTimes = currentItem.data.map((item) => item.x.slice(0, 5)); // Extract only HH:mm



//         return (

//           formattedDate === currentItem.date &&

//           currentTimes.includes(extractedTime)

//         );

//       })

//       .map(({ time, close }) => ({

//         x: time.slice(0, 5), // ✅ Annotation on X-axis (Vertical line)

//         borderColor: "#a987ebbf",

//         strokeDashArray: 0,

//         label: {

//           // text: `Time: ${time.slice(0,5)}`, // Show time label

//           position: "top", // Show at the top of the vertical line

//           style: {

//             color: "#fff",

//             background: "#a987ebbf",

//             fontSize: "12px",

//           },

//         },

//       }));



//     // console.log("xAnnotations" , xAnnotations)

//     const getInterval = (range) => {

//       if (range === "1hour") return 5;

//       else if (range === "2hour") return 10;

//       return 1;

//     };



//     const interval = getInterval(selectedhour);

//     const chartOption = {

//       chart: {

//         type: "candlestick",

//         zoom: { enabled: false },

//         toolbar: { show: false },

//       },

//       tooltip: {

//         enabled: true, // Enable tooltips

//       },

//       xaxis: {

//         type: "category",

//         labels: {

//           // formatter: (value, timestampIndex) => {

//           //    console.log("value" , value)

//           //   const [hour, minute] = value?.split(":").map(Number);

//           //   const totalMinutes = hour * 60 + minute;



//           //   return totalMinutes % interval === 0 ? value : "";

//           // },

//           // formatter: (value) => {

//           //   // Safe checks for string like "HH:mm"

//           //   if (!value || typeof value !== "string" || !value.includes(":")) return "";



//           //   const [hour, minute] = value.split(":").map(Number);

//           //   const totalMinutes = hour * 60 + minute;



//           //   // Show label only at 5-minute intervals

//           //   return totalMinutes % 5 === 0 ? value : "";

//           // },

//           formatter: (value, timestampIndex) => {

//             if (!value || typeof value !== "string" || !value.includes(":"))

//               return "";



//             const [hour, minute] = value.split(":").map(Number);

//             const totalMinutes = hour * 60 + minute;



//             let gapInterval = 1;



//             switch (selectedhour) {

//               case "30min":

//                 gapInterval = 1;

//                 break;

//               case "1hour":

//               case "2hour":

//                 gapInterval = 5;

//                 break;



//               default:

//                 gapInterval = 1;

//                 break;

//             }



//             // Return the time if it's divisible by the gap interval, otherwise an empty string

//             return totalMinutes % gapInterval === 0 ? value : "";

//           },



//           style: {

//             fontSize: "14px",

//             fontWeight: "bold",

//             fontFamily: "Open Sans",

//           },

//         },

//       },



//       yaxis: {

//         labels: {

//           formatter: (val) => (val !== undefined ? val.toFixed(5) : ""),

//           style: {

//             fontSize: "14px",

//             fontWeight: "bold",

//             fontFamily: "Open Sans",

//           },

//         },

//       },

//       annotations: {

//         xaxis: [

//           {

//             x: firstCandle,

//             x2: lastCandle,

//             fillColor:

//               directions[index]?.sign == "Positive"

//                 ? "#78e9a0bd"

//                 : directions[index]?.sign == "Negative"

//                 ? "#ff8e8ec4"

//                 : "#ffeb55b3",

//             opacity: 0.3,

//           },

//           ...xAnnotations,

//         ],

//       },

//       plotOptions: {

//         candlestick: {

//           barWidth: "2%",

//         },

//       },

//     };



//     chartOptions.push(chartOption);

//   });



//   useEffect(() => {

//     document.body.style.backgroundColor = "#d2c2f070"; // Change to your desired color

//     return () => {

//       document.body.style.backgroundColor = ""; // Reset on unmount

//     };

//   }, []);



//   const handleTimehour = (values) => {

//     setSelectedhour(values);

//   };

//   return (

//     <>

//       {/* <div className="bg-[#d2c2f070] "> */}

//       <div className={` `}>

//         <div className="flex flex-col text-[#240d3a] mx-[4%] pl-[4px]">

//           <h1 className="font-bold text-start mx-5 mt-5 text-[20px] sm:text-[20px] md:text-[24px] lg:text-[24px] xl:text-[24px]">

//             {/* Here are the charts of country: */}

//             Candlestick charts for :

//             <span className="font-semibold "> {eventname}</span>

//           </h1>

//           <h1 className="font-semibold text-start mx-5 text-[18px]">

//             Country : <span className="font-bold"> {countryname}</span>

//           </h1>

//         </div>

//         <div className="font-bold justify-center items-center text-[20px] w-[100%] flex text-[#240d3a]">

//           {noDataAvailable && <p>No data available for this country.</p>}

//         </div>

//         <div className="max-w-[100%] mx-[4%] p-0 sm:p-0 md:p-0 lg:p-4 xl:p-4 ">

//           {loading ? (

//             <div className="h-[100vh]">

//               <div className="font-semibold m-6 font-xl text-center flex justify-center items-center">

//                 Wait for charts .....

//               </div>



//               <div className="loader-container w-full flex justify-center ">

//                 <img

//                   src={loader_video}

//                   title="loader"

//                   alt="loader"

//                   className="w-[300px] h-[300px]"

//                   autoPlay

//                   loop

//                   muted

//                 />

//               </div>

//               {/* </div> */}

//             </div>

//           ) : fullScreenIndex === null ? (

//             <div className="">

//               <div className="flex justify-end items-center">

//                 {/* Dropdown to select model */}

//                 <div>

//                   <select

//                     className="p-2 border border-[#bcb7c7] rounded-md text-[#240d3a] bg-transparent h-[46px] mr-2"

//                     value={selectedModel}

//                     onChange={(e) => setSelectedModel(e.target.value)}

//                   >

//                     {Array.from(

//                       new Set(seriesData.map((series) => series.model))

//                     ).map((model) => (

//                       <option key={model} value={model}>

//                         {model}

//                       </option>

//                     ))}

//                   </select>

//                 </div>

//                 {/* <---dropdown---> */}

//                 <div className="relative flex justify-center items-center pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">

//                   <Space

//                     style={{

//                       width: "100%",

//                       paddingTop: 0,

//                       height: "46px",

//                     }}

//                     direction="vertical"

//                   >

//                     <FormControl sx={{ width: 101, height: 46 }}>

//                       <InputLabel id="time-select-label">

//                         Select Time

//                       </InputLabel>

//                       <Select

//                         labelId="time-select-label"

//                         value={selectedhour}

//                         // defaultValue="30min"

//                         onChange={(e) => handleTimehour(e.target.value)}

//                         label="Select Time"

//                         sx={{ height: 46 }}

//                       >

//                         <MenuItem value="30min">30 min</MenuItem>

//                         <MenuItem value="1hour">1 hour</MenuItem>

//                         <MenuItem value="2hour">2 hour</MenuItem>

//                       </Select>

//                     </FormControl>

//                   </Space>

//                   {loading1 && (

//                     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">

//                       <div className="w-[300px] h-[300px]">

//                         <img

//                           src={loader_video}

//                           title="loader"

//                           alt="loader"

//                           className="w-full h-full object-contain"

//                           autoPlay

//                           loop

//                           muted

//                         />

//                       </div>

//                     </div>

//                   )}

//                 </div>

//               </div>

//               {/* Show only the selected model's graphs */}

//               <div className="flex flex-wrap">

//                 {filteredSeriesData.map((series, index) => (

//                   <div key={index} className="w-full md:w-1/2 p-2 px-4">

//                     <div

//                       className={`rounded-md p-4 bg-[#fff] cursor-pointer`}

//                       onClick={() => handleGraphClick(index)}

//                     >

//                       <div>

//                         <h4 className="font-semibold text-[240D3A] ">

//                           {" "}

//                           News Direction : {directions[index]?.sign}{" "}

//                         </h4>

//                         <h2 className="text-center mb-4 font-semibold text-[24px] text-[240D3A]">

//                           {series.model} - {series.date}

//                         </h2>

//                       </div>

//                       {/* <div className={`${colorData[index]?.color || "bg-[#d2c3ec3b]"}`}> */}

//                       <ReactApexChart

//                         series={[{ data: series.data }]}

//                         options={chartOptions[index]}

//                         type="candlestick"

//                         height={400}

//                       />

//                       {/* </div> */}

//                     </div>

//                   </div>

//                 ))}

//               </div>

//             </div>

//           ) : (

//             <>

//               <button

//                 className=" bg-[#240d3a] flex justify-center items-center absolute top-[7%] md:top-[6%] right-[5%]  text-white py-2 px-6  rounded-md font-bold text-[13px] md:text-[20px] mb-5 "

//                 onClick={handleCloseFullScreen}

//               >

//                 <BsArrowLeft className="mr-2" />

//                 Back

//               </button>

//               {fullScreenIndex !== null &&

//                 filteredSeriesData[fullScreenIndex] && (

//                   <div className="mt-5 inset-0 bg-[#fff] z-50 flex flex-col items-center justify-center">

//                     <h2 className="text-center mb-4 font-semibold text-[240D3A]">

//                       {filteredSeriesData[fullScreenIndex]?.model} -{" "}

//                       {filteredSeriesData[fullScreenIndex]?.date}

//                     </h2>

//                     <div className="w-[100%] min-w-[100%]">

//                       <ReactApexChart

//                         series={[

//                           {

//                             data:

//                               filteredSeriesData[fullScreenIndex]?.data || [],

//                           },

//                         ]}

//                         options={chartOptions[fullScreenIndex] || {}}

//                         type="candlestick"

//                         height={700}

//                         ref={(el) => (chartRefs.current[fullScreenIndex] = el)}

//                       />

//                     </div>

//                   </div>

//                 )}

//             </>

//           )}

//         </div>

//       </div>

//     </>

//   );

// };



// export default CandleUser;



import React, { useEffect, useState, useMemo, useRef } from "react";

import { fetchStockData } from "./services";

import formatStockData from "./utils";

import ReactApexChart from "react-apexcharts";

import { Bars } from "react-loader-spinner";

import { BsArrowLeft } from "react-icons/bs";

import loader_video from "../assets/loaderaltra.gif";

import axios from "axios";

import { IoArrowBack } from "react-icons/io5";

import moment from "moment";

import { json, useNavigate } from "react-router-dom";

import { Space } from "antd";

import { DownOutlined } from "@ant-design/icons";

import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

import { LineWave } from "react-loader-spinner";



// <---this is the file of generate graphs OF eventhistory PAGE----> URL : graphdata ------->

const CandleUserCommodity = () => {

  const navigate = useNavigate();

  const [stockData, setStockData] = useState([]);

  const [countryname, setcountryname] = useState("");

  const [eventname, seteventname] = useState("");

  const [eventdate, seteventdate] = useState("");

  const [loading, setLoading] = useState(true);

  const [loading1, setLoading1] = useState(true);



  // Durgesh Changes

  const [eventRange, setEventRange] = useState("6");



  const handleOptionChange = (value) => {

    setEventRange(value);

    // setOptionValue(value)

    console.log("value", value);

  };



  const chartRefs = useRef([]);

  const [noDataAvailable, setNoDataAvailable] = useState(false);

  const [fullScreenIndex, setFullScreenIndex] = useState(null);

  //  const [selectedModel, setSelectedModel] = useState("GBP/USD");

  const [selectedModel, setSelectedModel] = useState("");

  const [selectedhour, setSelectedhour] = useState("30min");



  const [extractedDateandTime, setExtractedDateandTime] = useState([]);

  const [directions, setDirections] = useState([]);
  const directionLookup = useMemo(() => {
    const lookup = new Map();
    directions.forEach((entry) => {
      lookup.set(entry.date, entry);
    });
    return lookup;
  }, [directions]);

  const getDirectionColor = (sign) => {
    if (sign === "Positive") return "#78e9a036";
    if (sign === "Negative") return "#ff8e8e52";
    if (sign === "Flat") return "#ffeb552b";
    return "#ffffff";
  };


  console.log("directions", directions);

  const findHighLow = (dataArray) => {

    let highestHigh = -Infinity;

    let lowestLow = Infinity;



    dataArray.forEach((item) => {

      if (

        item &&

        typeof item.High === "number" &&

        typeof item.Low === "number"

      ) {

        highestHigh = Math.max(highestHigh, item.High);

        lowestLow = Math.min(lowestLow, item.Low);

      }

    });



    return { highestHigh, lowestLow };

  };



  // Previous that merge the consecutive date graph



  // const seriesData = useMemo(() => {

  //   // console.log("stockData" , stockData)

  //   // Step 1: Group raw data by model and date (each group represents one date)

  //   const rawGroups = stockData.flatMap((item) => {

  //     const dateGroups = {};



  //     // Group data points by date for this item

  //     item.data.forEach((point) => {

  //       const date = point.date;

  //       if (!dateGroups[date]) {

  //         dateGroups[date] = [];

  //       }

  //       dateGroups[date].push(point);

  //     });



  //     // console.log("dateGroups" , dateGroups)

  //     // Create a group for each date with flattened data points

  //     return Object.keys(dateGroups).map((date) => {

  //       const flattenedData = dateGroups[date].map((point) => ({

  //         x: point.time.slice(0, 5), // e.g., "23:45"

  //         y: [

  //           parseFloat(point.Open),

  //           parseFloat(point.High),

  //           parseFloat(point.Low),

  //           parseFloat(point.Close),

  //         ],

  //       }));

  //       return {

  //         model: item.model,

  //         date, // Date as provided, e.g. "06.02.2024"



  //         data: flattenedData,

  //       };

  //     });

  //   });



  //   // Step 2: Group the raw groups by model

  //   const groupsByModel = rawGroups.reduce((acc, group) => {

  //     if (!acc[group.model]) {

  //       acc[group.model] = [];

  //     }

  //     acc[group.model].push(group);

  //     return acc;

  //   }, {});



  //   // Step 3: For each model, merge consecutive dates (in ascending order)

  //   // and then sort the merged groups in descending order for display.

  //   const mergedGroupsByModel = {};

  //   Object.keys(groupsByModel).forEach((model) => {

  //     // Sort groups in ascending order (earliest date first)

  //     const sortedGroups = groupsByModel[model].sort((a, b) =>

  //       moment(a.date, "DD.MM.YYYY").diff(moment(b.date, "DD.MM.YYYY"))

  //     );

  //     const mergedGroups = [];

  //     let mergedGroup = { ...sortedGroups[0] }; // start with the earliest group

  //     let lastDate = moment(mergedGroup.date, "DD.MM.YYYY");



  //     for (let i = 1; i < sortedGroups.length; i++) {

  //       const currentGroup = sortedGroups[i];

  //       const currentDate = moment(currentGroup.date, "DD.MM.YYYY");

  //       // Check if current date is exactly one day after lastDate

  //       if (currentDate.diff(lastDate, "days") === 1) {

  //         // Merge the data arrays; they remain in ascending order because we sorted ascendingly.

  //         mergedGroup.data = [...mergedGroup.data, ...currentGroup.data];

  //         lastDate = currentDate;

  //       } else {

  //         // Not consecutive: push the current merged group and reset.

  //         mergedGroups.push(mergedGroup);

  //         mergedGroup = { ...currentGroup };

  //         lastDate = currentDate;

  //       }

  //     }

  //     // Push the final merged group for this model

  //     mergedGroups.push(mergedGroup);



  //     // Now sort merged groups in descending order (for display)

  //     mergedGroupsByModel[model] = mergedGroups.sort((a, b) =>

  //       moment(b.date, "DD.MM.YYYY").diff(moment(a.date, "DD.MM.YYYY"))

  //     );

  //   });



  //   // Step 4: Flatten the groups across models if needed

  //   const finalMergedGroups = Object.values(mergedGroupsByModel).flat();

  //   return finalMergedGroups;

  // }, [stockData]);











  // Durgesh updated to uniquely show each date graph without merging

  const seriesData = useMemo(() => {

    console.log("stockData", stockData)



    // Step 1: Group raw data by model and date (each group represents one date)

    const rawGroups = stockData.flatMap((item) => {

      const dateGroups = {};



      // Group data points by date for this item

      item.data.forEach((point) => {

        const date = point.date;

        if (!dateGroups[date]) {

          dateGroups[date] = [];

        }

        dateGroups[date].push(point);

      });



      console.log("dateGroups", dateGroups)

      // Create a group for each date separately (NO MERGING)

      return Object.keys(dateGroups).map((date, index) => {

        const flattenedData = dateGroups[date].map((point) => ({

          x: point.time.slice(0, 5), // e.g., "23:45"

          y: [

            parseFloat(point.Open),

            parseFloat(point.High),

            parseFloat(point.Low),

            parseFloat(point.Close),

          ],

        }));

        return {

          model: item.model,

          date, // Date as provided, e.g. "06.02.2024"

          originalIndex: index, // Add original index to maintain order

          data: flattenedData,

        };

      });

    });



    // Step 2: Group the raw groups by model (NO MERGING)

    const groupsByModel = rawGroups.reduce((acc, group) => {

      if (!acc[group.model]) {

        acc[group.model] = [];

      }

      acc[group.model].push(group);

      return acc;

    }, {});





    console.log("groupsByModel (no merging):", groupsByModel);



    // Step 3: Sort each model's groups by date in descending order (NO MERGING)

    const sortedGroupsByModel = {};

    Object.keys(groupsByModel).forEach((model) => {

      sortedGroupsByModel[model] = groupsByModel[model].sort((a, b) =>

        moment(b.date, "DD.MM.YYYY").diff(moment(a.date, "DD.MM.YYYY"))

      );

    });



    console.log("sortedGroupsByModel (no merging):", sortedGroupsByModel);



    // Step 4: Flatten the groups across models

    const finalGroups = Object.values(sortedGroupsByModel).flat();



    console.log("Final seriesData (no merging):", finalGroups);

    console.log(

      "Total groups per model:",

      Object.keys(sortedGroupsByModel).map((model) => ({

        model,

        count: sortedGroupsByModel[model].length,

      }))

    );



    return finalGroups;

  }, [stockData]);













  const filteredSeriesData = seriesData.filter(

    (series) => series.model === selectedModel

  );



  // console.log("Filtered series data count:", filteredSeriesData.length);

  // console.log("Filtered series data:", filteredSeriesData);



  // useEffect(() => {

  //   if (seriesData.length > 0) {

  //     setSelectedModel(seriesData[0].model);

  //   }

  // }, [seriesData]);

  //   useEffect(() => {

  //   if (seriesData.length > 0) {

  //     setSelectedModel(seriesData[0].model);

  //   }

  // }, [seriesData]);



  //Durgesh code changes 
  // const chartConfigMap = useMemo(() => {
  //   const map = new Map();

  //   filteredSeriesData.forEach((currentItem) => {
  //     const fullData = currentItem.data;
  //     if (!fullData || fullData.length === 0) return;

  //     // ---- 1) Window size: 30 / 60 / 120 min (news ke baad ka part) ----
  //     const afterNewsMinutes =
  //       selectedhour === "30min"
  //         ? 30
  //         : selectedhour === "1hour"
  //         ? 60
  //         : selectedhour === "2hour"
  //         ? 120
  //         : 30;

  //     // ---- 2) Is date ka event time nikaalo (extractedDateandTime se) ----
  //     // extractedDateandTime me date format: YYYY.MM.DD
  //     const eventForThisDate = extractedDateandTime.find(({ date }) => {
  //       const formattedDate = date.split(".").reverse().join("."); // DD.MM.YYYY -> YYYY.MM.DD
  //       return formattedDate === currentItem.date;
  //     });

  //     let windowStartMinutes;
  //     let windowEndMinutes;

  //     if (eventForThisDate && eventForThisDate.time) {
  //       // ✅ Anchor window on event time: 5 min before + afterNewsMinutes
  //       const eventTimeStr = eventForThisDate.time.slice(0, 5); // "HH:mm"
  //       const [eh = 0, em = 0] = eventTimeStr.split(":").map(Number);
  //       const eventTotalMinutes = eh * 60 + em;

  //       windowStartMinutes = eventTotalMinutes - 5; // 5 min pehle
  //       windowEndMinutes = eventTotalMinutes + afterNewsMinutes; // +30 / +60 / +120

  //       if (windowStartMinutes < 0) windowStartMinutes = 0;
  //       if (windowEndMinutes < 0) windowEndMinutes = 0;
  //     } else {
  //       // ⚠️ Fallback: agar event time na mile to last candle se window lo
  //       const lastCandleTime = fullData[fullData.length - 1]?.x;
  //       if (!lastCandleTime) return;

  //       const [lastHour = 0, lastMin = 0] = lastCandleTime
  //         .split(":")
  //         .map((segment) => Number(segment));
  //       const lastTotalMinutes = lastHour * 60 + lastMin;

  //       // last candle se 5 min pehle tak end window
  //       const offsetMinutes = 5;
  //       windowEndMinutes = lastTotalMinutes - offsetMinutes;
  //       if (windowEndMinutes < 0) windowEndMinutes = 0;

  //       windowStartMinutes = windowEndMinutes - afterNewsMinutes;
  //       if (windowStartMinutes < 0) windowStartMinutes = 0;
  //     }

  //     // ---- 3) Window ke andar wale candles hi dikhana ----
  //     let visibleData = fullData.filter((item) => {
  //       if (!item.x || typeof item.x !== "string") return false;
  //       const [h = 0, m = 0] = item.x.split(":").map(Number);
  //       const timeInMinutes = h * 60 + m;
  //       return (
  //         timeInMinutes >= windowStartMinutes && timeInMinutes <= windowEndMinutes
  //       );
  //     });

  //     // Agar window me kuch nahi mila, to last 2 candles show
  //     if (visibleData.length === 0) {
  //       visibleData = fullData.slice(-Math.min(fullData.length, 2));
  //     }

  //     // safety: sort by time
  //     visibleData = [...visibleData].sort((a, b) => {
  //       const [ah, am] = a.x.split(":").map(Number);
  //       const [bh, bm] = b.x.split(":").map(Number);
  //       return ah * 60 + am - (bh * 60 + bm);
  //     });

  //     const xCategories = visibleData.map((d) => d.x);

  //     // ---- 4) Direction ke hisaab se background color ----
  //     const directionMeta = directionLookup.get(currentItem.date) || null;
  //     const fillColor =
  //       directionMeta?.sign === "Positive"
  //         ? "#78e9a0bd"
  //         : directionMeta?.sign === "Negative"
  //         ? "#ff8e8ec4"
  //         : "#ffeb55b3";

  //     const chartBackgroundColor = getDirectionColor(directionMeta?.sign);
  //     const gridOpacity = directionMeta ? 0.3 : 0;

  //     const visibleFirst = xCategories[0] || fullData[0]?.x;
  //     const visibleLast =
  //       xCategories[xCategories.length - 1] ||
  //       visibleFirst ||
  //       fullData[fullData.length - 1]?.x;

  //     let backgroundAnnotation = [];
  //     if (visibleFirst && visibleLast) {
  //       backgroundAnnotation = [
  //         {
  //           x: visibleFirst,
  //           x2: visibleLast,
  //           fillColor,
  //           opacity: 0.3,
  //         },
  //       ];
  //     }

  //     // ---- 5) Event vertical line annotations ----
  //     const xAnnotations = extractedDateandTime
  //       .filter(({ date, time }) => {
  //         const formattedDate = date.split(".").reverse().join("."); // DD.MM.YYYY -> YYYY.MM.DD
  //         const extractedTime = time.slice(0, 5); // "HH:mm"
  //         return (
  //           formattedDate === currentItem.date &&
  //           xCategories.includes(extractedTime)
  //         );
  //       })
  //       .map(({ time }) => ({
  //         x: time.slice(0, 5),
  //         borderColor: "#a987ebbf",
  //         strokeDashArray: 0,
  //         label: {
  //           position: "top",
  //           style: { color: "#fff", background: "#a987ebbf", fontSize: "12px" },
  //         },
  //       }));

  //     // ---- 6) X-axis label gap (jaise screenshot me 2–2 minute ka) ----
  //     const gapInterval =
  //       selectedhour === "30min"
  //         ? 2 // 👉 01:26, 01:28, 01:30, ...
  //         : selectedhour === "1hour" || selectedhour === "2hour"
  //         ? 5
  //         : 2;

  //     const chartOption = {
  //       chart: {
  //         type: "candlestick",
  //         zoom: { enabled: false },
  //         toolbar: { show: false },
  //         background: chartBackgroundColor,
  //       },
  //       tooltip: { enabled: true },
  //       xaxis: {
  //         type: "category",
  //         categories: xCategories,
  //         labels: {
  //           formatter: (value) => {
  //             if (!value || !value.includes(":")) return "";
  //             const [h, m] = value.split(":").map(Number);
  //             const total = h * 60 + m;
  //             // sirf gapInterval ke multiple pe label show karo
  //             return total % gapInterval === 0 ? value : "";
  //           },
  //           style: {
  //             fontSize: "14px",
  //             fontWeight: "bold",
  //             fontFamily: "Open Sans",
  //           },
  //         },
  //       },
  //       yaxis: {
  //         labels: {
  //           formatter: (val) => (val !== undefined ? val.toFixed(5) : ""),
  //           style: {
  //             fontSize: "14px",
  //             fontWeight: "bold",
  //             fontFamily: "Open Sans",
  //           },
  //         },
  //       },
  //       annotations: {
  //         xaxis: [...backgroundAnnotation, ...xAnnotations],
  //       },
  //       plotOptions: {
  //         candlestick: { barWidth: "2%" },
  //       },
  //       grid: {
  //         row: {
  //           colors: [chartBackgroundColor],
  //           opacity: gridOpacity,
  //         },
  //       },
  //     };

  //     const configKey = `${currentItem.model}-${currentItem.date}`;
  //     map.set(configKey, {
  //       options: chartOption,
  //       series: [{ data: visibleData }],
  //     });
  //   });

  //   return map;
  // }, [filteredSeriesData, selectedhour, extractedDateandTime, directionLookup]);



  //next day will if event is 23:50 and window is 2 hour then candle of 00:00 to 01:50 will be shown by adding 1440 to it
  const chartConfigMap = useMemo(() => {
    const map = new Map();

    filteredSeriesData.forEach((currentItem) => {
      const fullData = currentItem.data;
      if (!fullData || fullData.length === 0) return;

      // ---- 1) Window size: 30 / 60 / 120 min (news ke baad ka part) ----
      const afterNewsMinutes =
        selectedhour === "30min"
          ? 30
          : selectedhour === "1hour"
            ? 60
            : selectedhour === "2hour"
              ? 120
              : 30;

      // ---- 2) Is date ka event time nikaalo (extractedDateandTime se) ----
      // extractedDateandTime me date format: YYYY.MM.DD
      const eventForThisDate = extractedDateandTime.find(({ date }) => {
        const formattedDate = date.split(".").reverse().join("."); // DD.MM.YYYY -> YYYY.MM.DD
        return formattedDate === currentItem.date;
      });

      const DAY_MINUTES = 24 * 60;
      let windowStartMinutes;
      let windowEndMinutes;
      let crossesMidnight = false;
      let eventTotalMinutes = null;

      if (eventForThisDate && eventForThisDate.time) {
        // ✅ Anchor window on event time: 5 min before + afterNewsMinutes
        const eventTimeStr = eventForThisDate.time.slice(0, 5); // "HH:mm"
        const [eh = 0, em = 0] = eventTimeStr.split(":").map(Number);
        eventTotalMinutes = eh * 60 + em;

        windowStartMinutes = eventTotalMinutes - 5; // 5 min pehle
        windowEndMinutes = eventTotalMinutes + afterNewsMinutes; // +30 / +60 / +120

        if (windowStartMinutes < 0) windowStartMinutes = 0;

        // ⚠️ Agar 2 hour window ki wajah se next day cross ho raha hai
        if (windowEndMinutes >= DAY_MINUTES) {
          crossesMidnight = true;
        }
      } else {
        // ⚠️ Fallback: agar event time na mile to last candle se window lo
        const lastCandleTime = fullData[fullData.length - 1]?.x;
        if (!lastCandleTime) return;

        const [lastHour = 0, lastMin = 0] = lastCandleTime
          .split(":")
          .map((segment) => Number(segment));
        const lastTotalMinutes = lastHour * 60 + lastMin;

        // last candle se 5 min pehle tak end window
        const offsetMinutes = 5;
        windowEndMinutes = lastTotalMinutes - offsetMinutes;
        if (windowEndMinutes < 0) windowEndMinutes = 0;

        windowStartMinutes = windowEndMinutes - afterNewsMinutes;
        if (windowStartMinutes < 0) windowStartMinutes = 0;
      }

      // Helper: time ko timeline minutes me convert karo
      // Cross-midnight case me 00:xx / 01:xx ko +1440 karke aage le jaate hain
      const getTimelineMinutes = (timeStr) => {
        if (!timeStr || typeof timeStr !== "string" || !timeStr.includes(":")) {
          return null;
        }
        const [h = 0, m = 0] = timeStr.split(":").map(Number);
        let base = h * 60 + m;

        if (crossesMidnight) {
          // e.g. event 23:50, 2 hour window => windowEndMinutes ≈ 1550
          // next-day candles: 00:00–01:50 => 0–110 => inko +1440 karna hai
          const overflowLimit = windowEndMinutes - DAY_MINUTES; // 1550 - 1440 = 110
          if (base <= overflowLimit) {
            base += DAY_MINUTES;
          }
        }

        return base;
      };

      // ---- 3) Window ke andar wale candles hi dikhana ----
      let visibleData = fullData.filter((item) => {
        const t = getTimelineMinutes(item.x);
        if (t == null) return false;
        return t >= windowStartMinutes && t <= windowEndMinutes;
      });

      // Agar window me kuch nahi mila, to last 2 candles show
      if (visibleData.length === 0) {
        visibleData = fullData.slice(-Math.min(fullData.length, 2));
      }

      // safety: sort by timeline minutes (midnight-cross ko respect karega)
      visibleData = [...visibleData].sort((a, b) => {
        const ta = getTimelineMinutes(a.x) ?? 0;
        const tb = getTimelineMinutes(b.x) ?? 0;
        return ta - tb;
      });

      const xCategories = visibleData.map((d) => d.x);

      // ---- 4) Direction ke hisaab se background color ----
      const directionMeta = directionLookup.get(currentItem.date) || null;
      const fillColor =
        directionMeta?.sign === "Positive"
          ? "#78e9a0bd"
          : directionMeta?.sign === "Negative"
            ? "#ff8e8ec4"
            : "#ffeb55b3";

      const chartBackgroundColor = getDirectionColor(directionMeta?.sign);
      const gridOpacity = directionMeta ? 0.3 : 0;

      const visibleFirst = xCategories[0] || fullData[0]?.x;
      const visibleLast =
        xCategories[xCategories.length - 1] ||
        visibleFirst ||
        fullData[fullData.length - 1]?.x;

      let backgroundAnnotation = [];
      if (visibleFirst && visibleLast) {
        backgroundAnnotation = [
          {
            x: visibleFirst,
            x2: visibleLast,
            fillColor,
            opacity: 0.3,
          },
        ];
      }

      // ---- 5) Event vertical line annotations ----
      const xAnnotations = extractedDateandTime
        .filter(({ date, time }) => {
          const formattedDate = date.split(".").reverse().join("."); // DD.MM.YYYY -> YYYY.MM.DD
          const extractedTime = time.slice(0, 5); // "HH:mm"
          return (
            formattedDate === currentItem.date &&
            xCategories.includes(extractedTime)
          );
        })
        .map(({ time }) => ({
          x: time.slice(0, 5),
          borderColor: "#a987ebbf",
          strokeDashArray: 0,
          label: {
            position: "top",
            style: { color: "#fff", background: "#a987ebbf", fontSize: "12px" },
          },
        }));

      // ---- 6) X-axis label gap ----
      const gapInterval =
        selectedhour === "30min"
          ? 2 // 👉 01:26, 01:28, 01:30, ...
          : selectedhour === "1hour" || selectedhour === "2hour"
            ? 5
            : 2;

      const chartOption = {
        chart: {
          type: "candlestick",
          zoom: { enabled: false },
          toolbar: { show: false },
          background: chartBackgroundColor,
        },
        tooltip: { enabled: true },
        xaxis: {
          type: "category",
          categories: xCategories,
          labels: {
            formatter: (value) => {
              const t = getTimelineMinutes(value);
              if (t == null) return "";
              // sirf gapInterval ke multiple pe label show karo
              return t % gapInterval === 0 ? value : "";
            },
            style: {
              fontSize: "14px",
              fontWeight: "bold",
              fontFamily: "Open Sans",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => (val !== undefined ? val.toFixed(5) : ""),
            style: {
              fontSize: "14px",
              fontWeight: "bold",
              fontFamily: "Open Sans",
            },
          },
        },
        annotations: {
          xaxis: [...backgroundAnnotation, ...xAnnotations],
        },
        plotOptions: {
          candlestick: { barWidth: "2%" },
        },
        grid: {
          row: {
            colors: [chartBackgroundColor],
            opacity: gridOpacity,
          },
        },
      };

      const configKey = `${currentItem.model}-${currentItem.date}`;
      map.set(configKey, {
        options: chartOption,
        series: [{ data: visibleData }],
      });
    });

    return map;
  }, [filteredSeriesData, selectedhour, extractedDateandTime, directionLookup]);




  useEffect(() => {

    if (

      seriesData.length > 0 &&

      (!selectedModel || !seriesData.some((s) => s.model === selectedModel))

    ) {

      setSelectedModel(seriesData[0].model);

    }

  }, [seriesData, selectedModel]);



  const handleGraphClick = (index) => {

    setFullScreenIndex(index); // Set the clicked graph to full screen

  };



  const handleCloseFullScreen = () => {

    setFullScreenIndex(null); // Reset to hide full-screen

  };



  const [EventData, SetEventData] = useState([]);



  // const final_Movement = async () => {

  //   try {

  //     setLoading1(true);

  //     const urlParams = new URLSearchParams(window.location.search);

  //     const eventName = decodeURIComponent(urlParams.get("eventName"));

  //     const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));

  //     const eventdate = decodeURIComponent(urlParams.get("eventdate"));





  //     // console.log("selectedhour" , selectedhour)

  //     const response = await axios.post(

  //       `${process.env.REACT_APP_URL}/graph`,

  //       // {

  //       //   params: {

  //       //     eventRange: eventRange,

  //       //   },

  //       // },

  //       {

  //         eventRange: eventRange,

  //         eventName,

  //         eventcountry,

  //         selectedhour,

  //         eventdate

  //       }

  //     );

  //     const data = response.data.finalData;

  //     const getExtractedTime = response.data.extractedDatesAndTimes;

  //     // console.log("getExtractedTime" , getExtractedTime)



  //     setExtractedDateandTime(getExtractedTime);

  //  console.log("I am the data comoing from the backend" ,data)

  //     setStockData(data);

  //     seteventname(eventName);

  //     setcountryname(eventcountry);



  //     // console.log("response.data.findevent" , response.data.findevent)

  //     SetEventData(response.data.findevent);

  //     console.log("EventData kush", response.data.findevent);

  //     setLoading1(false);

  //     setLoading(false);

  //   } catch (error) {

  //     console.error("Error fetching data:", error);

  //     console.log("error", error);

  //   }

  // };



  const final_Movement = async () => {

    try {

      setLoading1(true);

      const urlParams = new URLSearchParams(window.location.search);

      const eventName = decodeURIComponent(urlParams.get("eventName"));

      const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));

      const eventdate = decodeURIComponent(urlParams.get("eventdate"));



      // 👇 Add this — default to "1min" if not specified

      const eventType = "1min"; // or get from state if dynamic



      const response = await axios.post(`${process.env.REACT_APP_URL}/graphcommodity`, {

        eventRange: eventRange,

        eventName,

        eventcountry,

        selectedhour,

        eventdate,

        eventType, // 👈 MUST send this

      });



      const { finalData, extractedDatesAndTimes, findevent } = response.data;



      console.log("I am the data coming from the backend", finalData);

      console.log("Extracted Dates and Times:", extractedDatesAndTimes);



      setExtractedDateandTime(extractedDatesAndTimes);

      setStockData(finalData);

      seteventname(eventName);

      setcountryname(eventcountry);

      SetEventData(findevent); // ✅ Only events with volatility



      setLoading1(false);

      setLoading(false);

    } catch (error) {

      console.error("Error fetching data:", error);

      setLoading1(false);

      setLoading(false);

    }

  };







  // Update useEffect to re-run when eventRange changes

  useEffect(() => {

    final_Movement();

    fetchDatacolor(); // Optional: if you want directions to refresh too

  }, [selectedhour, eventRange]); // ✅ Now depends on eventRange



  const findColorForFinalMovement = () => {

    return EventData.map((item) => {

      let color, sign;



      if (

        item.estimate === null ||

        item.estimate === "" ||

        item.actual - item.estimate === 0

      ) {

        if (item.actual - item.previous > 0) {

          color = "bg-[#78e9a036]"; // Green

          sign = "Positive";

        } else if (item.actual - item.previous === 0) {

          color = "bg-[#ffeb552b]"; // Yellow

          sign = "Flat";

        } else {

          color = "bg-[#ff8e8e52]"; // Red

          sign = "Negative";

        }

      } else {

        if (item.actual - item.estimate > 0) {

          color = "bg-[#78e9a036]"; // Green

          sign = "Positive";

        } else if (item.actual - item.estimate === 0) {

          color = "bg-[#ffeb552b]"; // Yellow

          sign = "Flat";

        } else {

          color = "bg-[#ff8e8e52]"; // Red

          sign = "Negative";

        }

      }



      // console.log("color" , color , sign)

      return { color, sign };

    });

  };



  // const getNewsDirectionFromFinalMovement = (dataArray) => {

  //   return dataArray.map((item) => {

  //     const finalMovementNum = Number(item.finalMovement);

  //     let color, sign;



  //     if (finalMovementNum > 0) {

  //       color = "bg-[#78e9a036]"; // Green

  //       sign = "Positive";

  //     } else if (finalMovementNum === 0) {

  //       color = "bg-[#ffeb552b]"; // Yellow

  //       sign = "Flat";

  //     } else {

  //       color = "bg-[#ff8e8e52]"; // Red

  //       sign = "Negative";

  //     }



  //     return { color, sign };

  //   });

  // };

  // const getNewsDirectionFromFinalMovement = (dataArray) => {

  //   return dataArray.map((item) => {

  //     const finalMovementNum = Number(item.finalMovement);

  //     let color, sign;



  //     if (finalMovementNum > 0) {

  //       color = "bg-[#78e9a036]"; // Green

  //       sign = "Positive";

  //     } else if (finalMovementNum === 0) {

  //       color = "bg-[#ffeb552b]"; // Yellow

  //       sign = "Flat";

  //     } else {

  //       color = "bg-[#ff8e8e52]"; // Red

  //       sign = "Negative";

  //     }



  //     return {

  //       color,

  //       sign,

  //       date: item.date, // Add date here

  //       // Optional: include time

  //     };

  //   });

  // };


  const getNewsDirectionFromFinalMovement = (dataArray) => {
    console.log("🔍 getNewsDirectionFromFinalMovement called with:", dataArray);

    return dataArray.map((item, index) => {
      console.log(`\n📊 Item ${index}:`, {
        actualminusestimate: item.actualminusestimate,
        actualminusprevious: item.actualminusprevious,
        date: item.date
      });

      // Prefer actualminusestimate if valid, else fallback to actualminusprevious
      let rawValue =
        item.actualminusestimate !== undefined &&
          item.actualminusestimate !== null &&
          item.actualminusestimate !== "" &&
          !isNaN(Number(item.actualminusestimate))
          ? item.actualminusestimate
          : item.actualminusprevious;

      console.log(`   Selected rawValue: ${rawValue}`);

      const finalMovementNum = Number(rawValue);
      console.log(`   finalMovementNum: ${finalMovementNum}, isNaN: ${isNaN(finalMovementNum)}`);

      let color, sign;
      if (finalMovementNum > 0) {
        color = "bg-[#78e9a036]"; // Green
        sign = "Positive";
      } else if (finalMovementNum === 0) {
        color = "bg-[#ffeb552b]"; // Yellow
        sign = "Flat";
      } else if (finalMovementNum < 0) {
        color = "bg-[#ff8e8e52]"; // Red
        sign = "Negative";
      } else {
        // NaN case
        color = "bg-gray-200";
        sign = "N/A";
      }

      console.log(`   ✅ Result: sign=${sign}, color=${color}`);

      // Reformat YYYY.MM.DD -> DD.MM.YYYY
      const [yyyy, mm, dd] = item.date.split(".");
      const formattedDate = `${dd}.${mm}.${yyyy}`;

      return {
        color,
        sign,
        date: formattedDate,
        // time/event can be added if required
      };
    });
  };


  // const getNewsDirectionFromFinalMovement = (dataArray) => {

  //   return dataArray.map((item) => {

  //     console.log("item" , item)

  //     const finalMovementNum = Number(item.actualminusestimate);

  //     console.log("finalMovementNum" , finalMovementNum)

  //     let color, sign;



  //     if (finalMovementNum > 0) {

  //       color = "bg-[#78e9a036]"; // Green

  //       sign = "Positive";

  //     } else if (finalMovementNum === 0) {

  //       color = "bg-[#ffeb552b]"; // Yellow

  //       sign = "Flat";

  //     } else {

  //       color = "bg-[#ff8e8e52]"; // Red

  //       sign = "Negative";

  //     }



  //     // Reformat date from 'YYYY.MM.DD' -> 'DD.MM.YYYY'

  //     const [yyyy, mm, dd] = item.date.split(".");

  //     const formattedDate = `${dd}.${mm}.${yyyy}`;



  //     return {

  //       color,

  //       sign,

  //       date: formattedDate,

  //       // Optional: include time or event if needed

  //     };

  //   });

  // };



  const fetchDatacolor = async () => {

    try {

      const urlParams = new URLSearchParams(window.location.search);

      const eventId = decodeURIComponent(urlParams.get("eventId"));

      console.log("eventId", eventId);

      // alert(eventId);

      const response = await fetch(

        `${process.env.REACT_APP_URL}/user/geteventcommodity/${eventId}?eventRange=${eventRange}&eventType=1min`

      );

      if (!response.ok) {

        throw new Error(`HTTP error! status: ${response.status}`);

      }

      const json = await response.json();

      const volatilityOutput = json.volatilityEvent?.data?.output || [];

      console.log("Me VOL RES", volatilityOutput);

      const calculatedDirections =

        getNewsDirectionFromFinalMovement(volatilityOutput);

      console.log("calculatedDirections kk", calculatedDirections);

      setDirections(calculatedDirections);

    } catch (e) {

      console.log(e.message);

    } finally {

      // setLoading(false);

    }

  };

  const colorData = findColorForFinalMovement();



  useEffect(() => {

    final_Movement();

    findColorForFinalMovement();

    fetchDatacolor();

  }, [selectedhour]);

  // previous code problem: chartOptions array fell out of sync when 30 min filters returned zero candles,
  // which left some models without tinted backgrounds. Keeping this block for reference.
  /*
  let chartOptions = [];



  // filteredSeriesData.map((currentItem, index) => {

  //   const firstCandle = currentItem.data[0]?.x; // First candle x-axis value

  //   const lastCandle = currentItem.data[currentItem.data.length - 1]?.x; // Last candle x-axis value

  //   // console.log("firstCandle" , firstCandle , lastCandle)

  //   // console.log("colorData[index]?.sign" , colorData[index]?.sign)

  //   const xAnnotations = extractedDateandTime

  //     .filter(({ date, time }) => {

  //       const formattedDate = date.split(".").reverse().join("."); // Convert to YYYY.MM.DD

  //       const extractedTime = time.slice(0, 5); // Extract "HH:mm" from "HH:mm:ss"

  //       const currentTimes = currentItem.data.map((item) => item.x.slice(0, 5)); // Extract only HH:mm



  //       return (

  //         formattedDate === currentItem.date &&

  //         currentTimes.includes(extractedTime)

  //       );

  //     })

  //     .map(({ time, close }) => ({

  //       x: time.slice(0, 5), // ✅ Annotation on X-axis (Vertical line)

  //       borderColor: "#a987ebbf",

  //       strokeDashArray: 0,

  //       label: {

  //         // text: `Time: ${time.slice(0,5)}`, // Show time label

  //         position: "top", // Show at the top of the vertical line

  //         style: {

  //           color: "#fff",

  //           background: "#a987ebbf",

  //           fontSize: "12px",

  //         },

  //       },

  //     }));



  //   // console.log("xAnnotations" , xAnnotations)

  //   const getInterval = (range) => {

  //     if (range === "1hour") return 5;

  //     else if (range === "2hour") return 10;

  //     return 1;

  //   };



  //   const interval = getInterval(selectedhour);

  //   const chartOption = {

  //     chart: {

  //       type: "candlestick",

  //       zoom: { enabled: false },

  //       toolbar: { show: false },

  //     },

  //     tooltip: {

  //       enabled: true, // Enable tooltips

  //     },

  //     xaxis: {

  //       type: "category",

  //       labels: {

  //         // formatter: (value, timestampIndex) => {

  //         //    console.log("value" , value)

  //         //   const [hour, minute] = value?.split(":").map(Number);

  //         //   const totalMinutes = hour * 60 + minute;



  //         //   return totalMinutes % interval === 0 ? value : "";

  //         // },

  //         // formatter: (value) => {

  //         //   // Safe checks for string like "HH:mm"

  //         //   if (!value || typeof value !== "string" || !value.includes(":")) return "";



  //         //   const [hour, minute] = value.split(":").map(Number);

  //         //   const totalMinutes = hour * 60 + minute;



  //         //   // Show label only at 5-minute intervals

  //         //   return totalMinutes % 5 === 0 ? value : "";

  //         // },

  //         formatter: (value, timestampIndex) => {

  //           if (!value || typeof value !== "string" || !value.includes(":"))

  //             return "";



  //           const [hour, minute] = value.split(":").map(Number);

  //           const totalMinutes = hour * 60 + minute;



  //           let gapInterval = 1;



  //           switch (selectedhour) {

  //             case "30min":

  //               gapInterval = 1;

  //               break;

  //             case "1hour":

  //             case "2hour":

  //               gapInterval = 5;

  //               break;



  //             default:

  //               gapInterval = 1;

  //               break;

  //           }



  //           // Return the time if it's divisible by the gap interval, otherwise an empty string

  //           return totalMinutes % gapInterval === 0 ? value : "";

  //         },



  //         style: {

  //           fontSize: "14px",

  //           fontWeight: "bold",

  //           fontFamily: "Open Sans",

  //         },

  //       },

  //     },



  //     yaxis: {

  //       labels: {

  //         formatter: (val) => (val !== undefined ? val.toFixed(5) : ""),

  //         style: {

  //           fontSize: "14px",

  //           fontWeight: "bold",

  //           fontFamily: "Open Sans",

  //         },

  //       },

  //     },

  //     annotations: {

  //       xaxis: [

  //         {

  //           x: firstCandle,

  //           x2: lastCandle,

  //           fillColor: (() => {

  //             const dir = directions.find((d) => d.date === currentItem.date);

  //             return dir?.sign === "Positive"

  //               ? "#78e9a0bd"

  //               : dir?.sign === "Negative"

  //               ? "#ff8e8ec4"

  //               : "#ffeb55b3";

  //           })(),

  //           opacity: 0.3,

  //         },

  //         ...xAnnotations,

  //       ],



  //       //  [

  //       //   {

  //       //     x: firstCandle,

  //       //     x2: lastCandle,

  //       //     fillColor:

  //       //       directions[index]?.sign == "Positive"

  //       //         ? "#78e9a0bd"

  //       //         : directions[index]?.sign == "Negative"

  //       //         ? "#ff8e8ec4"

  //       //         : "#ffeb55b3",

  //       //     opacity: 0.3,

  //       //   },

  //       //   ...xAnnotations,

  //       // ],

  //     },

  //     plotOptions: {

  //       candlestick: {

  //         barWidth: "2%",

  //       },

  //     },

  //   };



  //   chartOptions.push(chartOption);

  // });







  filteredSeriesData.forEach((currentItem, index) => {

    // ====== 1. Get full day range for background color (UNFILTERED) ======

    const fullData = currentItem.data;

    if (!fullData || fullData.length === 0) return;



    const fullFirst = fullData[0]?.x; // e.g., "09:00"

    const fullLast = fullData[fullData.length - 1]?.x; // e.g., "11:00"



    // ====== 2. Filter visible data based on selected time range ======

    const cutoffMinutes =

      selectedhour === "30min"

        ? 30

        : selectedhour === "1hour"

        ? 60

        : selectedhour === "2hour"

        ? 120

        : 30;



    const lastCandleTime = fullLast;

    if (!lastCandleTime) return;



    const [endHour, endMin] = lastCandleTime.split(":").map(Number);

    const endTimeInMinutes = endHour * 60 + endMin;



    const visibleData = fullData.filter((item) => {

      if (!item.x || typeof item.x !== "string") return false;

      const [h, m] = item.x.split(":").map(Number);

      const timeInMinutes = h * 60 + m;

      return (

        endTimeInMinutes - timeInMinutes <= cutoffMinutes &&

        timeInMinutes <= endTimeInMinutes

      );

    });



    if (visibleData.length === 0) return;



    const xCategories = visibleData.map((d) => d.x);



    // ====== 3. Get direction color (date-based) ======

    // previous code problem: annotation used all-day timestamps so filtered views (30 min) never overlapped and lost the fill color

    // const dir = directions.find((d) => d.date === currentItem.date);

    // const fillColor =

    // dir?.sign === "Positive"

    // ? "#78e9a0bd"

    // : dir?.sign === "Negative"

    // ? "#ff8e8ec4"

    // : "#ffeb55b3";

    //

    // // ✅ CRITICAL: Use FULL DAY range for background (not visible range)

    // let backgroundAnnotation = [];

    // if (fullFirst && fullLast) {

    // backgroundAnnotation = [

    // {

    // x: fullFirst,

    // x2: fullLast,

    // fillColor,

    // opacity: 0.3,

    // },

    // ];

    // }

    //

    // durgesh changes: keep annotation inside visible window so positive/negative colors always render

    const dir = directions.find((d) => d.date === currentItem.date);

    const fillColor =

      dir?.sign === "Positive"

        ? "#78e9a0bd"

        : dir?.sign === "Negative"

        ? "#ff8e8ec4"

        : "#ffeb55b3";

    const visibleFirst = visibleData[0]?.x; // start annotation at first displayed candle

    const visibleLast = visibleData[visibleData.length - 1]?.x; // end annotation at last displayed candle

    let backgroundAnnotation = [];

    if (visibleFirst && visibleLast) {

      backgroundAnnotation = [

        {

          x: visibleFirst,

          x2: visibleLast,

          fillColor,

          opacity: 0.3,

        },

      ];

    } else if (fullFirst && fullLast) {

      backgroundAnnotation = [

        {

          x: fullFirst,

          x2: fullLast,

          fillColor,

          opacity: 0.3,

        },

      ];

    }



    // ====== 4. X-axis annotations (for event markers) ======

    const xAnnotations = extractedDateandTime

      .filter(({ date, time }) => {

        const formattedDate = date.split(".").reverse().join("."); // DD.MM.YYYY → YYYY.MM.DD

        const extractedTime = time.slice(0, 5); // "HH:mm"

        return (

          formattedDate === currentItem.date &&

          xCategories.includes(extractedTime)

        );

      })

      .map(({ time }) => ({

        x: time.slice(0, 5),

        borderColor: "#a987ebbf",

        strokeDashArray: 0,

        label: {

          position: "top",

          style: { color: "#fff", background: "#a987ebbf", fontSize: "12px" },

        },

      }));



    // ====== 5. Label interval ======

    const gapInterval =

      selectedhour === "30min"

        ? 2

        : selectedhour === "1hour" || selectedhour === "2hour"

        ? 5

        : 2;



    // ====== 6. Chart options ======

    const chartOption = {

      chart: {

        type: "candlestick",

        zoom: { enabled: false },

        toolbar: { show: false },

      },

      tooltip: { enabled: true },

      xaxis: {

        type: "category",

        categories: xCategories,

        labels: {

          formatter: (value) => {

            if (!value || !value.includes(":")) return "";

            const [h, m] = value.split(":").map(Number);

            return (h * 60 + m) % gapInterval === 0 ? value : "";

          },

          style: {

            fontSize: "14px",

            fontWeight: "bold",

            fontFamily: "Open Sans",

          },

        },

      },

      yaxis: {

        labels: {

          formatter: (val) => (val !== undefined ? val.toFixed(5) : ""),

          style: {

            fontSize: "14px",

            fontWeight: "bold",

            fontFamily: "Open Sans",

          },

        },

      },

      annotations: {

        xaxis: [...backgroundAnnotation, ...xAnnotations],

      },

      plotOptions: {

        candlestick: { barWidth: "2%" },

      },

      series: [{ data: visibleData }],

    };



    chartOptions.push(chartOption);

  });

  */



  useEffect(() => {

    document.body.style.backgroundColor = "#d2c2f070"; // Change to your desired color

    return () => {

      document.body.style.backgroundColor = ""; // Reset on unmount

    };

  }, []);



  const handleTimehour = (values) => {

    setSelectedhour(values);

  };

  return (
    <>
      <div className="relative min-h-screen w-full bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 overflow-x-hidden">
        {/* Animated Background Elements */}
        <div className="fixed inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
          <div className="absolute top-40 right-20 w-96 h-96 bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute bottom-20 left-1/2 w-80 h-80 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
        </div>

        <div
          className={`relative max-w-[96%] mx-auto px-4 md:px-6 lg:px-10 py-8 ${loading || loading1 ? "pointer-events-none select-none" : ""
            }`}
        >
          {/* Header Section - Enhanced */}
          <div className="relative mb-8">
            <div className="bg-white/60 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/40">
              <div className="flex flex-col space-y-3">
                <h1 className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-indigo-600 to-purple-700 text-[32px] md:text-[42px] lg:text-[48px] leading-tight">
                  Candlestick Charts
                </h1>
                <div className="flex flex-col sm:flex-row sm:items-center gap-3 text-[18px] md:text-[22px]">
                  <div className="flex items-center gap-2">
                    <span className="text-slate-600 font-medium">Event:</span>
                    <span className="font-bold text-purple-700 bg-purple-100 px-4 py-1.5 rounded-full">{eventname}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-slate-600 font-medium">Country:</span>
                    <span className="font-bold text-indigo-700 bg-indigo-100 px-4 py-1.5 rounded-full">{countryname}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* No Data */}
          {noDataAvailable && (
            <div className="flex justify-center my-12">
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-8 border border-white/60">
                <p className="text-2xl font-bold text-slate-700">No data available for this country.</p>
              </div>
            </div>
          )}

          {/* ===== MAIN LOADER ===== */}
          {loading && (
            <div
              className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-3xl bg-gradient-to-br from-purple-900/50 via-indigo-900/50 to-pink-900/50"
              role="status"
              aria-live="polite"
            >
              <div className="flex flex-col items-center justify-center rounded-3xl shadow-2xl px-12 py-10 bg-white/95 backdrop-blur-md border-2 border-purple-200">
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 text-2xl font-bold mb-6">
                  Loading Charts...
                </p>
                <img
                  src={loader_video}
                  alt="Loading..."
                  className="w-[280px] h-[280px] object-contain drop-shadow-2xl"
                  autoPlay
                  loop
                  muted
                />
              </div>
            </div>
          )}

          {/* ===== SECONDARY LOADER ===== */}
          {!loading && loading1 && (
            <div
              className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-2xl bg-gradient-to-br from-purple-600/30 via-indigo-600/30 to-pink-600/30"
              role="status"
              aria-live="polite"
            >
              <div className="flex flex-col items-center justify-center bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl px-12 py-10 border-2 border-indigo-200">
                <img
                  src={loader_video}
                  alt="loader"
                  className="w-[250px] h-[250px] object-contain mb-5 drop-shadow-xl"
                />
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 font-bold text-2xl">
                  Fetching Data...
                </p>
              </div>
            </div>
          )}

          {/* Main Section */}
          {!loading && (
            <>
              {fullScreenIndex === null ? (
                <div>
                  {/* Control Bar - Enhanced Glassmorphism */}
                  <div className="sticky top-4 z-40 mb-8">
                    <div className="bg-white/70 backdrop-blur-2xl rounded-2xl shadow-xl border border-white/50 p-5">
                      <div className="flex flex-wrap justify-end items-center gap-4">
                        {/* Model Dropdown */}
                        <select
                          className="px-5 py-3 border-2 border-purple-200 rounded-xl text-slate-800 bg-white/90 backdrop-blur-sm font-semibold text-[16px] h-[54px] focus:ring-4 focus:ring-purple-300 focus:border-purple-400 transition-all shadow-lg hover:shadow-xl cursor-pointer"
                          value={selectedModel}
                          onChange={(e) => setSelectedModel(e.target.value)}
                        >
                          {Array.from(
                            new Set(seriesData.map((series) => series.model))
                          ).map((model) => (
                            <option key={model} value={model}>
                              {model}
                            </option>
                          ))}
                        </select>

                        {/* Time Dropdown */}
                        <FormControl sx={{ minWidth: 160, height: 54 }}>
                          <InputLabel
                            id="time-select-label"
                            sx={{
                              fontSize: "16px",
                              fontWeight: 600,
                              color: "#6b21a8"
                            }}
                          >
                            Select Time
                          </InputLabel>
                          <Select
                            labelId="time-select-label"
                            value={selectedhour}
                            onChange={(e) => handleTimehour(e.target.value)}
                            label="Select Time"
                            sx={{
                              height: 54,
                              fontSize: "16px",
                              fontWeight: 600,
                              bgcolor: "rgba(255, 255, 255, 0.9)",
                              borderRadius: "12px",
                              boxShadow: "0 10px 30px rgba(139, 92, 246, 0.15)",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#e9d5ff",
                                borderWidth: "2px",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#c084fc",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#a855f7",
                                borderWidth: "2px",
                              },
                            }}
                          >
                            <MenuItem value="30min" sx={{ fontWeight: 600 }}>30 min</MenuItem>
                            <MenuItem value="1hour" sx={{ fontWeight: 600 }}>1 hour</MenuItem>
                            <MenuItem value="2hour" sx={{ fontWeight: 600 }}>2 hour</MenuItem>
                          </Select>
                        </FormControl>

                        {/* Range Dropdown */}
                        <FormControl sx={{ minWidth: 180, height: 54 }}>
                          <InputLabel
                            id="range-select-label"
                            sx={{
                              fontSize: "16px",
                              fontWeight: 600,
                              color: "#4338ca"
                            }}
                          >
                            Select Range
                          </InputLabel>
                          <Select
                            labelId="range-select-label"
                            value={eventRange}
                            onChange={(e) => handleOptionChange(e.target.value)}
                            label="Select Range"
                            sx={{
                              height: 54,
                              fontSize: "16px",
                              fontWeight: 600,
                              bgcolor: "rgba(255, 255, 255, 0.9)",
                              borderRadius: "12px",
                              boxShadow: "0 10px 30px rgba(99, 102, 241, 0.15)",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#ddd6fe",
                                borderWidth: "2px",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#a78bfa",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#7c3aed",
                                borderWidth: "2px",
                              },
                            }}
                          >
                            <MenuItem value="6" sx={{ fontWeight: 600 }}>Last 6</MenuItem>
                            <MenuItem value="12" sx={{ fontWeight: 600 }}>Last 12</MenuItem>
                            <MenuItem value="24" sx={{ fontWeight: 600 }}>Last 24</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>

                  {/* Charts Grid - Enhanced Cards */}
                  <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
                    {filteredSeriesData.map((series, index) => {
                      const chartKey = `${series.model}-${series.date}`;
                      const chartConfig = chartConfigMap.get(chartKey);
                      const directionMeta = directionLookup.get(series.date);

                      // Dynamic color based on direction
                      const directionColor =
                        directionMeta?.sign === "Positive" ? "from-emerald-500 to-green-600" :
                          directionMeta?.sign === "Negative" ? "from-rose-500 to-red-600" :
                            "from-amber-500 to-orange-600";

                      return (
                        <div
                          key={chartKey}
                          className="group relative bg-white/80 backdrop-blur-xl border-2 border-white/60 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 p-7 cursor-pointer transform hover:scale-[1.02] hover:-translate-y-1"
                          onClick={() => handleGraphClick(index)}
                        >
                          {/* Gradient Top Border */}
                          <div className={`absolute top-0 left-0 right-0 h-2 bg-gradient-to-r ${directionColor} rounded-t-3xl`}></div>

                          {/* Card Header */}
                          <div className="flex justify-between items-start mb-5">
                            <div className="flex-1">
                              <div className="flex items-center gap-2 mb-2">
                                <span className="text-slate-600 font-semibold text-[15px]">Direction:</span>
                                <span className={`px-4 py-1.5 rounded-full font-bold text-[15px] text-white bg-gradient-to-r ${directionColor} shadow-md`}>
                                  {directionMeta?.sign || "N/A"}
                                </span>
                              </div>
                            </div>

                            {/* Date Badge */}
                            <div className="flex items-center bg-gradient-to-br from-purple-100 to-indigo-100 px-5 py-2.5 rounded-2xl shadow-md">
                              <span className="text-[17px] font-bold text-purple-800">
                                {series.date}
                              </span>
                            </div>
                          </div>

                          {/* Model Name */}
                          <h3 className="text-center text-[26px] md:text-[32px] font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-slate-800 to-slate-600 mb-6 tracking-tight">
                            {series.model}
                          </h3>

                          {/* Chart Container */}
                          <div className="relative rounded-2xl overflow-hidden border-2 border-purple-100 bg-white shadow-inner">
                            <ReactApexChart
                              series={
                                chartConfig?.series || [{ data: series.data }]
                              }
                              options={chartConfig?.options || {}}
                              type="candlestick"
                              height={520}
                            />
                          </div>

                          {/* Hover Indicator */}
                          <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                              Click to expand
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <>
                  {/* Fullscreen Mode - Enhanced */}
                  <button
                    className="fixed top-6 right-6 z-50 bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 px-8 rounded-2xl font-bold text-[17px] shadow-2xl hover:shadow-purple-500/50 hover:scale-105 transition-all duration-300 border-2 border-white/30"
                    onClick={handleCloseFullScreen}
                  >
                    <BsArrowLeft className="inline-block mr-2 text-xl" />
                    Back to Grid
                  </button>

                  {fullScreenIndex !== null &&
                    filteredSeriesData[fullScreenIndex] && (
                      <div className="mt-20 flex flex-col items-center justify-center px-4">
                        <div className="w-full max-w-[98%] bg-white/90 backdrop-blur-2xl border-2 border-white/60 rounded-3xl shadow-2xl p-8">
                          {/* Fullscreen Header */}
                          <div className="bg-gradient-to-r from-purple-600 via-indigo-600 to-purple-600 rounded-2xl p-6 mb-6 shadow-lg">
                            <h2 className="text-center font-bold text-[28px] md:text-[36px] text-white">
                              {filteredSeriesData[fullScreenIndex]?.model}
                            </h2>
                            <p className="text-center text-white/90 font-semibold text-[18px] md:text-[22px] mt-2">
                              {filteredSeriesData[fullScreenIndex]?.date}
                            </p>
                          </div>

                          {/* Fullscreen Chart */}
                          <div className="rounded-2xl overflow-hidden border-2 border-purple-200 shadow-inner bg-white">
                            {(() => {
                              const fullSeries =
                                filteredSeriesData[fullScreenIndex];
                              const chartKey = `${fullSeries.model}-${fullSeries.date}`;
                              const chartConfig = chartConfigMap.get(chartKey);
                              const resolvedSeries = chartConfig?.series || [
                                { data: fullSeries?.data || [] },
                              ];
                              const resolvedOptions =
                                chartConfig?.options || {};

                              return (
                                <ReactApexChart
                                  series={resolvedSeries}
                                  options={resolvedOptions}
                                  type="candlestick"
                                  height={800}
                                  ref={(el) =>
                                    (chartRefs.current[fullScreenIndex] = el)
                                  }
                                />
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    )}
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* Add Custom Animations */}
      <style jsx>{`
        @keyframes blob {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </>
  );


};







// My updated code durgesh 06-06-2024 if there is no direction then dont show the graph



// const CandleUser = () => {

//   const navigate = useNavigate();

//   const [stockData, setStockData] = useState([]);

//   const [countryname, setcountryname] = useState("");

//   const [eventname, seteventname] = useState("");

//   const [loading, setLoading] = useState(true);

//   const [loading1, setLoading1] = useState(true);

//   const chartRefs = useRef([]);

//   const [noDataAvailable, setNoDataAvailable] = useState(false);

//   const [fullScreenIndex, setFullScreenIndex] = useState(null);

//   //  const [selectedModel, setSelectedModel] = useState("GBP/USD");

//   const [selectedModel, setSelectedModel] = useState("");

//   const [selectedhour, setSelectedhour] = useState("30min");



//   const [extractedDateandTime, setExtractedDateandTime] = useState([]);

//   const [directions, setDirections] = useState([]);

//   const findHighLow = (dataArray) => {

//     let highestHigh = -Infinity;

//     let lowestLow = Infinity;



//     dataArray.forEach((item) => {

//       if (

//         item &&

//         typeof item.High === "number" &&

//         typeof item.Low === "number"

//       ) {

//         highestHigh = Math.max(highestHigh, item.High);

//         lowestLow = Math.min(lowestLow, item.Low);

//       }

//     });



//     return { highestHigh, lowestLow };

//   };



//   const seriesData = useMemo(() => {

//     // console.log("stockData" , stockData)

//     // Step 1: Group raw data by model and date (each group represents one date)

//     const rawGroups = stockData.flatMap((item) => {

//       const dateGroups = {};



//       // Group data points by date for this item

//       item.data.forEach((point) => {

//         const date = point.date;

//         if (!dateGroups[date]) {

//           dateGroups[date] = [];

//         }

//         dateGroups[date].push(point);

//       });



//       // console.log("dateGroups" , dateGroups)

//       // Create a group for each date with flattened data points

//       return Object.keys(dateGroups).map((date) => {

//         const flattenedData = dateGroups[date].map((point) => ({

//           x: point.time.slice(0, 5), // e.g., "23:45"

//           y: [

//             parseFloat(point.Open),

//             parseFloat(point.High),

//             parseFloat(point.Low),

//             parseFloat(point.Close),

//           ],

//         }));

//         return {

//           model: item.model,

//           date, // Date as provided, e.g. "06.02.2024"



//           data: flattenedData,

//         };

//       });

//     });



//     // Step 2: Group the raw groups by model

//     const groupsByModel = rawGroups.reduce((acc, group) => {

//       if (!acc[group.model]) {

//         acc[group.model] = [];

//       }

//       acc[group.model].push(group);

//       return acc;

//     }, {});



//     // Step 3: For each model, merge consecutive dates (in ascending order)

//     // and then sort the merged groups in descending order for display.

//     const mergedGroupsByModel = {};

//     Object.keys(groupsByModel).forEach((model) => {

//       // Sort groups in ascending order (earliest date first)

//       const sortedGroups = groupsByModel[model].sort((a, b) =>

//         moment(a.date, "DD.MM.YYYY").diff(moment(b.date, "DD.MM.YYYY"))

//       );

//       const mergedGroups = [];

//       let mergedGroup = { ...sortedGroups[0] }; // start with the earliest group

//       let lastDate = moment(mergedGroup.date, "DD.MM.YYYY");



//       for (let i = 1; i < sortedGroups.length; i++) {

//         const currentGroup = sortedGroups[i];

//         const currentDate = moment(currentGroup.date, "DD.MM.YYYY");

//         // Check if current date is exactly one day after lastDate

//         if (currentDate.diff(lastDate, "days") === 1) {

//           // Merge the data arrays; they remain in ascending order because we sorted ascendingly.

//           mergedGroup.data = [...mergedGroup.data, ...currentGroup.data];

//           lastDate = currentDate;

//         } else {

//           // Not consecutive: push the current merged group and reset.

//           mergedGroups.push(mergedGroup);

//           mergedGroup = { ...currentGroup };

//           lastDate = currentDate;

//         }

//       }

//       // Push the final merged group for this model

//       mergedGroups.push(mergedGroup);



//       // Now sort merged groups in descending order (for display)

//       mergedGroupsByModel[model] = mergedGroups.sort((a, b) =>

//         moment(b.date, "DD.MM.YYYY").diff(moment(a.date, "DD.MM.YYYY"))

//       );

//     });



//     // Step 4: Flatten the groups across models if needed

//     const finalMergedGroups = Object.values(mergedGroupsByModel).flat();

//     return finalMergedGroups;

//   }, [stockData]);



//   // useEffect(() => {

//   //   if (seriesData.length > 0) {

//   //     setSelectedModel(seriesData[0].model);

//   //   }

//   // }, [seriesData]);

//   //   useEffect(() => {

//   //   if (seriesData.length > 0) {

//   //     setSelectedModel(seriesData[0].model);

//   //   }

//   // }, [seriesData]);

//   useEffect(() => {

//     if (

//       seriesData.length > 0 &&

//       (!selectedModel || !seriesData.some((s) => s.model === selectedModel))

//     ) {

//       setSelectedModel(seriesData[0].model);

//     }

//   }, [seriesData, selectedModel]);



//   const filteredSeriesData = seriesData.filter(

//     (series) => series.model === selectedModel

//   );

//   console.log("filteredSeriesData", filteredSeriesData);

//   console.log("directions", directions);



//   // ADD THIS NEW FILTER

//   const filteredSeriesDataWithValidDirection = filteredSeriesData.filter(

//     (series) => {

//       const direction = directions.find((dir) => dir.date === series.date);

//       return direction && direction.sign && direction.sign !== "N/A";

//     }

//   );



//   const handleGraphClick = (index) => {

//     setFullScreenIndex(index); // Set the clicked graph to full screen

//   };



//   const handleCloseFullScreen = () => {

//     setFullScreenIndex(null); // Reset to hide full-screen

//   };



//   const [EventData, SetEventData] = useState([]);



//   const final_Movement = async () => {

//     try {

//       setLoading1(true);

//       const urlParams = new URLSearchParams(window.location.search);

//       const eventName = decodeURIComponent(urlParams.get("eventName"));

//       const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));



//       // console.log("selectedhour" , selectedhour)

//       const response = await axios.post(`${process.env.REACT_APP_URL}/graph`, {

//         eventName,

//         eventcountry,

//         selectedhour,

//       });

//       const data = response.data.finalData;

//       const getExtractedTime = response.data.extractedDatesAndTimes;

//       // console.log("getExtractedTime" , getExtractedTime)



//       setExtractedDateandTime(getExtractedTime);



//       setStockData(data);

//       seteventname(eventName);

//       setcountryname(eventcountry);



//       // console.log("response.data.findevent" , response.data.findevent)

//       SetEventData(response.data.findevent);

//       console.log("EventData kush", response.data.findevent);

//       setLoading1(false);

//       setLoading(false);

//     } catch (error) {

//       console.error("Error fetching data:", error);

//       console.log("error", error);

//     }

//   };



//   const findColorForFinalMovement = () => {

//     return EventData.map((item) => {

//       let color, sign;



//       if (

//         item.estimate === null ||

//         item.estimate === "" ||

//         item.actual - item.estimate === 0

//       ) {

//         if (item.actual - item.previous > 0) {

//           color = "bg-[#78e9a036]"; // Green

//           sign = "Positive";

//         } else if (item.actual - item.previous === 0) {

//           color = "bg-[#ffeb552b]"; // Yellow

//           sign = "Flat";

//         } else {

//           color = "bg-[#ff8e8e52]"; // Red

//           sign = "Negative";

//         }

//       } else {

//         if (item.actual - item.estimate > 0) {

//           color = "bg-[#78e9a036]"; // Green

//           sign = "Positive";

//         } else if (item.actual - item.estimate === 0) {

//           color = "bg-[#ffeb552b]"; // Yellow

//           sign = "Flat";

//         } else {

//           color = "bg-[#ff8e8e52]"; // Red

//           sign = "Negative";

//         }

//       }



//       // console.log("color" , color , sign)

//       return { color, sign };

//     });

//   };



//   // const getNewsDirectionFromFinalMovement = (dataArray) => {

//   //   return dataArray.map((item) => {

//   //     const finalMovementNum = Number(item.finalMovement);

//   //     let color, sign;



//   //     if (finalMovementNum > 0) {

//   //       color = "bg-[#78e9a036]"; // Green

//   //       sign = "Positive";

//   //     } else if (finalMovementNum === 0) {

//   //       color = "bg-[#ffeb552b]"; // Yellow

//   //       sign = "Flat";

//   //     } else {

//   //       color = "bg-[#ff8e8e52]"; // Red

//   //       sign = "Negative";

//   //     }



//   //     return { color, sign };

//   //   });

//   // };

//   // const getNewsDirectionFromFinalMovement = (dataArray) => {

//   //   return dataArray.map((item) => {

//   //     const finalMovementNum = Number(item.finalMovement);

//   //     let color, sign;



//   //     if (finalMovementNum > 0) {

//   //       color = "bg-[#78e9a036]"; // Green

//   //       sign = "Positive";

//   //     } else if (finalMovementNum === 0) {

//   //       color = "bg-[#ffeb552b]"; // Yellow

//   //       sign = "Flat";

//   //     } else {

//   //       color = "bg-[#ff8e8e52]"; // Red

//   //       sign = "Negative";

//   //     }



//   //     return {

//   //       color,

//   //       sign,

//   //       date: item.date, // Add date here

//   //       // Optional: include time

//   //     };

//   //   });

//   // };

//   const getNewsDirectionFromFinalMovement = (dataArray) => {

//     return dataArray.map((item) => {

//       const finalMovementNum = Number(item.finalMovement);

//       let color, sign;



//       if (finalMovementNum > 0) {

//         color = "bg-[#78e9a036]"; // Green

//         sign = "Positive";

//       } else if (finalMovementNum === 0) {

//         color = "bg-[#ffeb552b]"; // Yellow

//         sign = "Flat";

//       } else {

//         color = "bg-[#ff8e8e52]"; // Red

//         sign = "Negative";

//       }



//       // Reformat date from 'YYYY.MM.DD' -> 'DD.MM.YYYY'

//       const [yyyy, mm, dd] = item.date.split(".");

//       const formattedDate = `${dd}.${mm}.${yyyy}`;



//       return {

//         color,

//         sign,

//         date: formattedDate,

//         // Optional: include time or event if needed

//       };

//     });

//   };



//   const fetchDatacolor = async () => {

//     try {

//       const urlParams = new URLSearchParams(window.location.search);

//       const eventId = decodeURIComponent(urlParams.get("eventId"));

//       console.log("eventId", eventId);

//       // alert(eventId);

//       const response = await fetch(

//         `${process.env.REACT_APP_URL}/user/geteventtable/${eventId}?eventRange=6&eventType=1min`

//       );

//       if (!response.ok) {

//         throw new Error(`HTTP error! status: ${response.status}`);

//       }

//       const json = await response.json();

//       const volatilityOutput = json.volatilityEvent?.data?.output || [];

//       console.log("Me VOL RES", volatilityOutput);

//       const calculatedDirections =

//         getNewsDirectionFromFinalMovement(volatilityOutput);

//       console.log("calculatedDirections kk", calculatedDirections);

//       setDirections(calculatedDirections);

//     } catch (e) {

//       console.log(e.message);

//     } finally {

//       // setLoading(false);

//     }

//   };

//   const colorData = findColorForFinalMovement();



//   useEffect(() => {

//     final_Movement();

//     findColorForFinalMovement();

//     fetchDatacolor();

//   }, [selectedhour]);

//   let chartOptions = [];



//   filteredSeriesDataWithValidDirection.map((currentItem, index) => {

//     const firstCandle = currentItem.data[0]?.x; // First candle x-axis value

//     const lastCandle = currentItem.data[currentItem.data.length - 1]?.x; // Last candle x-axis value

//     // console.log("firstCandle" , firstCandle , lastCandle)

//     // console.log("colorData[index]?.sign" , colorData[index]?.sign)

//     const xAnnotations = extractedDateandTime

//       .filter(({ date, time }) => {

//         const formattedDate = date.split(".").reverse().join("."); // Convert to YYYY.MM.DD

//         const extractedTime = time.slice(0, 5); // Extract "HH:mm" from "HH:mm:ss"

//         const currentTimes = currentItem.data.map((item) => item.x.slice(0, 5)); // Extract only HH:mm



//         return (

//           formattedDate === currentItem.date &&

//           currentTimes.includes(extractedTime)

//         );

//       })

//       .map(({ time, close }) => ({

//         x: time.slice(0, 5), // ✅ Annotation on X-axis (Vertical line)

//         borderColor: "#a987ebbf",

//         strokeDashArray: 0,

//         label: {

//           // text: `Time: ${time.slice(0,5)}`, // Show time label

//           position: "top", // Show at the top of the vertical line

//           style: {

//             color: "#fff",

//             background: "#a987ebbf",

//             fontSize: "12px",

//           },

//         },

//       }));



//     // console.log("xAnnotations" , xAnnotations)

//     const getInterval = (range) => {

//       if (range === "1hour") return 5;

//       else if (range === "2hour") return 10;

//       return 1;

//     };



//     const interval = getInterval(selectedhour);

//     const chartOption = {

//       chart: {

//         type: "candlestick",

//         zoom: { enabled: false },

//         toolbar: { show: false },

//       },

//       tooltip: {

//         enabled: true, // Enable tooltips

//       },

//       xaxis: {

//         type: "category",

//         labels: {

//           // formatter: (value, timestampIndex) => {

//           //    console.log("value" , value)

//           //   const [hour, minute] = value?.split(":").map(Number);

//           //   const totalMinutes = hour * 60 + minute;



//           //   return totalMinutes % interval === 0 ? value : "";

//           // },

//           // formatter: (value) => {

//           //   // Safe checks for string like "HH:mm"

//           //   if (!value || typeof value !== "string" || !value.includes(":")) return "";



//           //   const [hour, minute] = value.split(":").map(Number);

//           //   const totalMinutes = hour * 60 + minute;



//           //   // Show label only at 5-minute intervals

//           //   return totalMinutes % 5 === 0 ? value : "";

//           // },

//           formatter: (value, timestampIndex) => {

//             if (!value || typeof value !== "string" || !value.includes(":"))

//               return "";



//             const [hour, minute] = value.split(":").map(Number);

//             const totalMinutes = hour * 60 + minute;



//             let gapInterval = 1;



//             switch (selectedhour) {

//               case "30min":

//                 gapInterval = 1;

//                 break;

//               case "1hour":

//               case "2hour":

//                 gapInterval = 5;

//                 break;



//               default:

//                 gapInterval = 1;

//                 break;

//             }



//             // Return the time if it's divisible by the gap interval, otherwise an empty string

//             return totalMinutes % gapInterval === 0 ? value : "";

//           },



//           style: {

//             fontSize: "14px",

//             fontWeight: "bold",

//             fontFamily: "Open Sans",

//           },

//         },

//       },



//       yaxis: {

//         labels: {

//           formatter: (val) => (val !== undefined ? val.toFixed(5) : ""),

//           style: {

//             fontSize: "14px",

//             fontWeight: "bold",

//             fontFamily: "Open Sans",

//           },

//         },

//       },

//       annotations: {

//         xaxis: [

//           {

//             x: firstCandle,

//             x2: lastCandle,

//             fillColor: (() => {

//               const dir = directions.find((d) => d.date === currentItem.date);

//               return dir?.sign === "Positive"

//                 ? "#78e9a0bd"

//                 : dir?.sign === "Negative"

//                 ? "#ff8e8ec4"

//                 : "#ffeb55b3";

//             })(),

//             opacity: 0.3,

//           },

//           ...xAnnotations,

//         ],



//         //  [

//         //   {

//         //     x: firstCandle,

//         //     x2: lastCandle,

//         //     fillColor:

//         //       directions[index]?.sign == "Positive"

//         //         ? "#78e9a0bd"

//         //         : directions[index]?.sign == "Negative"

//         //         ? "#ff8e8ec4"

//         //         : "#ffeb55b3",

//         //     opacity: 0.3,

//         //   },

//         //   ...xAnnotations,

//         // ],

//       },

//       plotOptions: {

//         candlestick: {

//           barWidth: "2%",

//         },

//       },

//     };



//     chartOptions.push(chartOption);

//   });



//   useEffect(() => {

//     document.body.style.backgroundColor = "#d2c2f070"; // Change to your desired color

//     return () => {

//       document.body.style.backgroundColor = ""; // Reset on unmount

//     };

//   }, []);



//   const handleTimehour = (values) => {

//     setSelectedhour(values);

//   };

//   return (

//     <>

//       {/* <div className="bg-[#d2c2f070] "> */}

//       <div className={` `}>

//         <div className="flex flex-col text-[#240d3a] mx-[4%] pl-[4px]">

//           <h1 className="font-bold text-start mx-5 mt-5 text-[20px] sm:text-[20px] md:text-[24px] lg:text-[24px] xl:text-[24px]">

//             {/* Here are the charts of country: */}

//             Candlestick charts for :

//             <span className="font-semibold "> {eventname}</span>

//           </h1>

//           <h1 className="font-semibold text-start mx-5 text-[18px]">

//             Country : <span className="font-bold"> {countryname}</span>

//           </h1>

//         </div>

//         <div className="font-bold justify-center items-center text-[20px] w-[100%] flex text-[#240d3a]">

//           {noDataAvailable && <p>No data available for this country.</p>}

//         </div>

//         <div className="max-w-[100%] mx-[4%] p-0 sm:p-0 md:p-0 lg:p-4 xl:p-4 ">

//           {loading ? (

//             <div className="h-[100vh]">

//               <div className="font-semibold m-6 font-xl text-center flex justify-center items-center">

//                 Wait for charts .....

//               </div>



//               <div className="loader-container w-full flex justify-center ">

//                 <img

//                   src={loader_video}

//                   title="loader"

//                   alt="loader"

//                   className="w-[300px] h-[300px]"

//                   autoPlay

//                   loop

//                   muted

//                 />

//               </div>

//               {/* </div> */}

//             </div>

//           ) : fullScreenIndex === null ? (

//             <div className="">

//               <div className="flex justify-end items-center">

//                 {/* Dropdown to select model */}

//                 <div>

//                   <select

//                     className="p-2 border border-[#bcb7c7] rounded-md text-[#240d3a] bg-transparent h-[46px] mr-2"

//                     value={selectedModel}

//                     onChange={(e) => setSelectedModel(e.target.value)}

//                   >

//                     {Array.from(

//                       new Set(seriesData.map((series) => series.model))

//                     ).map((model) => (

//                       <option key={model} value={model}>

//                         {model}

//                       </option>

//                     ))}

//                   </select>

//                 </div>

//                 {/* <---dropdown---> */}

//                 <div className="relative flex justify-center items-center pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">

//                   <Space

//                     style={{

//                       width: "100%",

//                       paddingTop: 0,

//                       height: "46px",

//                     }}

//                     direction="vertical"

//                   >

//                     <FormControl sx={{ width: 101, height: 46 }}>

//                       <InputLabel id="time-select-label">

//                         Select Time

//                       </InputLabel>

//                       <Select

//                         labelId="time-select-label"

//                         value={selectedhour}

//                         // defaultValue="30min"

//                         onChange={(e) => handleTimehour(e.target.value)}

//                         label="Select Time"

//                         sx={{ height: 46 }}

//                       >

//                         <MenuItem value="30min">30 min</MenuItem>

//                         <MenuItem value="1hour">1 hour</MenuItem>

//                         <MenuItem value="2hour">2 hour</MenuItem>

//                       </Select>

//                     </FormControl>

//                   </Space>

//                   {loading1 && (

//                     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">

//                       <div className="w-[300px] h-[300px]">

//                         <img

//                           src={loader_video}

//                           title="loader"

//                           alt="loader"

//                           className="w-full h-full object-contain"

//                           autoPlay

//                           loop

//                           muted

//                         />

//                       </div>

//                     </div>

//                   )}

//                 </div>

//               </div>

//               {/* Show only the selected model's graphs */}

//               <div className="flex flex-wrap">

//                 {console.log("filteredSeriesData", filteredSeriesData)}

//                 {filteredSeriesDataWithValidDirection.map((series, index) => (

//                   <div key={index} className="w-full md:w-1/2 p-2 px-4">

//                     <div

//                       className={`rounded-md p-4 bg-[#fff] cursor-pointer`}

//                       onClick={() => handleGraphClick(index)}

//                     >

//                       <div>

//                         {/* <h4 className="font-semibold text-[240D3A] ">

//                           {" "}

//                           News Direction : {directions[index]?.sign}{" "}

//                         </h4> */}

//                         <h4>

//                           News Direction :{" "}

//                           {directions.find((dir) => dir.date === series.date)

//                             ?.sign || "N/A"}

//                           {/* {JSON.stringify(directions)}

//                           series.date {series.date} */}

//                         </h4>

//                         <h2 className="text-center mb-4 font-semibold text-[24px] text-[240D3A]">

//                           {series.model} - {series.date}

//                         </h2>

//                       </div>

//                       {/* <div className={`${colorData[index]?.color || "bg-[#d2c3ec3b]"}`}> */}

//                       <ReactApexChart

//                         series={[{ data: series.data }]}

//                         options={chartOptions[index]}

//                         type="candlestick"

//                         height={400}

//                       />

//                       {/* </div> */}

//                     </div>

//                   </div>

//                 ))}

//               </div>

//             </div>

//           ) : (

//             <>

//               <button

//                 className=" bg-[#240d3a] flex justify-center items-center absolute top-[7%] md:top-[6%] right-[5%]  text-white py-2 px-6  rounded-md font-bold text-[13px] md:text-[20px] mb-5 "

//                 onClick={handleCloseFullScreen}

//               >

//                 <BsArrowLeft className="mr-2" />

//                 Back

//               </button>

//               {fullScreenIndex !== null &&

//                 filteredSeriesData[fullScreenIndex] && (

//                   <div className="mt-5 inset-0 bg-[#fff] z-50 flex flex-col items-center justify-center">

//                     <h2 className="text-center mb-4 font-semibold text-[240D3A]">

//                       {filteredSeriesData[fullScreenIndex]?.model} -{" "}

//                       {filteredSeriesData[fullScreenIndex]?.date}

//                     </h2>

//                     <div className="w-[100%] min-w-[100%]">

//                       <ReactApexChart

//                         series={[

//                           {

//                             data:

//                               filteredSeriesData[fullScreenIndex]?.data || [],

//                           },

//                         ]}

//                         options={chartOptions[fullScreenIndex] || {}}

//                         type="candlestick"

//                         height={700}

//                         ref={(el) => (chartRefs.current[fullScreenIndex] = el)}

//                       />

//                     </div>

//                   </div>

//                 )}

//             </>

//           )}

//         </div>

//       </div>

//     </>

//   );

// };

export default CandleUserCommodity;

